import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const CitiesToolbar = ({ 
  searchQuery, 
  onSearchChange, 
  selectedCount, 
  onAddCity, 
  onBulkDelete, 
  onExport, 
  onImport,
  currentLanguage,
  onLanguageChange,
  totalCount = 0,
  activeCount = 0 
}) => {
  const [showBulkActions, setShowBulkActions] = useState(false);

  const languages = [
    { code: 'ar', label: 'العربية', icon: 'Globe' },
    { code: 'en', label: 'English', icon: 'Globe' },
    { code: 'tr', label: 'Türkçe', icon: 'Globe' }
  ];

  const handleBulkAction = (action) => {
    switch (action) {
      case 'delete':
        onBulkDelete();
        break;
      case 'export':
        onExport();
        break;
      default:
        break;
    }
    setShowBulkActions(false);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Top Row - Main Actions */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        {/* Left Section - Title and Stats */}
        <div className="flex items-center space-x-4">
          <div>
            <h1 className="text-xl font-semibold text-foreground">إدارة المدن</h1>
            <div className="flex items-center space-x-4 mt-1 text-sm text-muted-foreground">
              <span>{totalCount} مدينة إجمالي</span>
              <span>•</span>
              <span className="text-success">{activeCount} نشطة</span>
              {selectedCount > 0 && (
                <>
                  <span>•</span>
                  <span className="text-primary">{selectedCount} محددة</span>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Right Section - Primary Actions */}
        <div className="flex items-center space-x-3">
          {/* Language Selector */}
          <div className="relative">
            <select
              value={currentLanguage}
              onChange={(e) => onLanguageChange(e?.target?.value)}
              className="appearance-none bg-background border border-border rounded-lg px-3 py-2 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            >
              {languages?.map((lang) => (
                <option key={lang?.code} value={lang?.code}>
                  {lang?.label}
                </option>
              ))}
            </select>
            <Icon 
              name="ChevronDown" 
              size={14} 
              className="absolute left-2 top-1/2 transform -translate-y-1/2 text-muted-foreground pointer-events-none" 
            />
          </div>

          {/* Add City Button */}
          <Button
            variant="default"
            onClick={onAddCity}
            iconName="Plus"
            iconPosition="left"
            className="whitespace-nowrap"
          >
            إضافة مدينة
          </Button>
        </div>
      </div>
      {/* Bottom Row - Search and Filters */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 mt-4 pt-4 border-t border-border">
        {/* Search */}
        <div className="flex-1 lg:max-w-md">
          <div className="relative">
            <Icon 
              name="Search" 
              size={18} 
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
            />
            <input
              type="text"
              placeholder="البحث في المدن..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full pl-4 pr-10 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary text-right"
              dir="rtl"
            />
            {searchQuery && (
              <Button
                variant="ghost"
                size="icon"
                className="absolute left-1 top-1/2 transform -translate-y-1/2 w-6 h-6"
                onClick={() => onSearchChange('')}
                iconName="X"
                iconSize={14}
              />
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center space-x-2">
          {/* Bulk Actions */}
          {selectedCount > 0 && (
            <div className="relative">
              <Button
                variant="outline"
                size="sm"
                onClick={() => setShowBulkActions(!showBulkActions)}
                iconName="MoreHorizontal"
                iconPosition="left"
              >
                إجراءات ({selectedCount})
              </Button>
              
              {showBulkActions && (
                <div className="absolute top-full right-0 mt-2 w-48 bg-popover border border-border rounded-lg shadow-elevation-2 py-2 z-200 animate-slide-up">
                  <button
                    className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-error hover:bg-muted transition-colors"
                    onClick={() => handleBulkAction('delete')}
                  >
                    <Icon name="Trash2" size={16} />
                    <span>حذف المحددة</span>
                  </button>
                  
                  <button
                    className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-colors"
                    onClick={() => handleBulkAction('export')}
                  >
                    <Icon name="Download" size={16} />
                    <span>تصدير المحددة</span>
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Export Button */}
          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            iconName="Download"
            iconPosition="left"
          >
            تصدير
          </Button>

          {/* Import Button */}
          <Button
            variant="outline"
            size="sm"
            onClick={onImport}
            iconName="Upload"
            iconPosition="left"
          >
            استيراد
          </Button>
        </div>
      </div>
      {/* Click Outside Handler for Bulk Actions */}
      {showBulkActions && (
        <div
          className="fixed inset-0 z-100"
          onClick={() => setShowBulkActions(false)}
        />
      )}
    </div>
  );
};

export default CitiesToolbar;